const organizations = {
    title: 'Organizaciones',
    description: 'Crea y administra las organizaciones a las que perteneces.',
    create: 'Crear organización',
    create_title: 'Crear una nueva organización',
    name: 'Nombre de la organización',
    avatar: 'Avatar de la organización',
    avatar_removed: 'Avatar de la organización eliminado.',
    description_label: 'Descripción',
    empty: 'Aún no perteneces a ninguna organización.',
    pending_invitations: 'Invitaciones pendientes',
    accept: 'Aceptar',
    decline: 'Rechazar',
    owner: 'Propietario',
    tabs: {
        overview: 'Resumen',
        members: 'Miembros',
        invitations: 'Invitaciones',
        roles: 'Roles de administración',
        branding: 'Identidad visual',
        security: 'Seguridad',
        jit: 'Aprovisionamiento JIT',
        applications: 'Recursos compartidos',
        activity: 'Actividad',
        deletion: 'Eliminar',
    },
    members: {
        title: 'Miembros',
        empty: 'No se encontraron miembros.',
        remove: 'Quitar',
        removed: 'Miembro eliminado.',
        business_roles: 'Roles de negocio',
        no_business_roles: 'No hay roles de negocio disponibles. Pide al administrador del tenant que comparta roles con esta organización.',
    },
    invitations: {
        title: 'Invitaciones',
        invite: 'Invitar miembro',
        email: 'Dirección de correo',
        empty: 'No se encontraron invitaciones.',
        resend: 'Reenviar',
        resent: 'Invitación reenviada.',
        revoke: 'Revocar',
        revoked: 'Invitación revocada.',
        status: {
            Pending: 'Pendiente',
            Accepted: 'Aceptada',
            Expired: 'Caducada',
            Revoked: 'Revocada',
            Declined: 'Rechazada',
        },
    },
    roles: {
        title: 'Roles de administración',
        create: 'Crear rol',
        permissions: 'Permisos',
        empty: 'No se encontraron roles de administración.',
        select_member: 'Seleccionar miembro',
        select_role: 'Seleccionar rol',
        assign: 'Asignar rol',
        assigned: 'Rol asignado.',
        unassign: 'Quitar rol',
        unassigned: 'Rol eliminado.',
        permission_count: 'Permisos: {{count}}',
        built_in: {
            owner: 'Propietario',
            owner_description: 'Los propietarios tienen control exclusivo sobre la propiedad y la eliminación de la organización.',
            administrator: 'Administrador',
            administrator_description: 'Administra la organización, excepto las acciones reservadas a los propietarios.',
        },
        permission_labels: {
            update_profile: 'Actualizar perfil',
            manage_branding: 'Administrar identidad visual',
            view_members: 'Ver miembros',
            manage_members: 'Administrar miembros',
            manage_invitations: 'Administrar invitaciones',
            assign_business_roles: 'Asignar roles de negocio',
            manage_management_roles: 'Administrar roles de administración',
            assign_management_roles: 'Asignar roles de administración',
            manage_security: 'Administrar seguridad',
            manage_jit: 'Administrar aprovisionamiento JIT',
            manage_applications: 'Administrar aplicaciones',
            view_activity: 'Ver actividad',
        },
    },
    branding: {
        title: 'Identidad visual de la organización',
        primary_color: 'Color principal',
        custom_css: 'CSS personalizado',
        preview: 'Vista previa',
        light: 'Claro',
        dark: 'Oscuro',
    },
    security: {
        title: 'Seguridad de la organización',
        require_mfa: 'Exigir autenticación multifactor a los miembros',
    },
    jit: {
        title: 'Dominios de correo JIT',
        domain: 'Dominio de correo',
        add: 'Añadir dominio',
        verify: 'Comprobar DNS',
        dns_instruction: 'Crea el registro TXT {{record}} con el valor {{value}}.',
        verified: 'Verificado',
    },
    applications: {
        title: 'Recursos compartidos',
        empty: 'No hay recursos disponibles para esta organización.',
        sso: 'Conexiones SSO empresariales',
        m2m: 'Aplicaciones máquina a máquina',
    },
    activity: {
        title: 'Actividad de la organización',
        empty: 'Aún no hay actividad.',
        events: {
            create: 'Organización creada',
            delete: 'Organización eliminada',
            profile: 'Perfil de la organización actualizado',
            branding: 'Identidad visual actualizada',
            security: 'Seguridad de la organización actualizada',
            member_add: 'Miembro añadido',
            member_remove: 'Miembro eliminado',
            owner: 'Propiedad de la organización actualizada',
            role_create: 'Rol de administración creado',
            role_update: 'Rol de administración actualizado',
            role_delete: 'Rol de administración eliminado',
            role_assign: 'Rol de administración asignado',
            role_unassign: 'Rol de administración retirado del miembro',
            business_role: 'Roles de negocio actualizados',
            invitation_create: 'Invitación enviada',
            invitation_accept: 'Invitación aceptada',
            invitation_decline: 'Invitación rechazada',
            invitation_revoke: 'Invitación revocada',
            jit: 'Aprovisionamiento JIT actualizado',
            domain: 'Verificación del dominio de correo',
            application: 'Conexiones de aplicaciones actualizadas',
            unknown: 'Actividad de la organización',
        },
    },
    save: 'Guardar cambios',
    cancel: 'Cancelar',
    delete: 'Eliminar organización',
    delete_confirmation: 'Se eliminarán permanentemente la organización y sus membresías. Introduce «{{name}}» para confirmar.',
    deleted: 'Organización eliminada.',
    load_failed: 'No se pudieron cargar los datos de la organización. Inténtalo de nuevo.',
    permission_denied: 'No tienes permiso para ver esta sección.',
};
export default organizations;
